import React from 'react';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import WorkListCard from '../../../shared/work/list/WorkListCard';
import { PsCompanyManagement } from '../../../shared/model/PsCompanyManagement';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import { CardStorageManager } from '../../../shared/utils/CardStorageManager';

export class WorkListScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_WORKS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MIS_OBRAS')} breadcrumbs={breadcrumbs}>
                <WorkListCard
                    companyManagement={PsCompanyManagement.MY_OUTSOURCES}
                    saveCardState={this.saveCardState}
                    initialCardState={this.readCardState()}
                />
            </PsPage>
        );
    }

    saveCardState = (state) => {
        this.cardStorageManager.saveCard('myWorks', state);
    };

    readCardState = () => {
        return this.cardStorageManager.readCard('myWorks');
    };
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/work/list/WorkListScreen.jsx